// import React from 'react';
import './Atoms.scss';
import Input from './Input';
import Label from './Label';
import Button from './Button';
import ImgTag from './ImgTag';
import UlList from './UlList';

// const Atoms = () => {
//     const otherAttribs= {};
//     otherAttribs['name'] = 'ebcss-input-name';
//     otherAttribs['data-id'] = 'ebcss-input-data-id';
//     const labelValue = 'New Label';
//     const buttonValue = 'Submit Button';
//     return (
//         <div
//             className='atoms-container'
//         >
//             <h1>Atoms</h1>
//             <Label
//                 className = 'ebcss-label'
//                 labelFor = '#input'
//                 id = 'ebcssLabel'
//                 otherAttribs = {otherAttribs}
//                 value = {labelValue}
//             />
//             <Input
//                 className = 'ebcss-input'
//                 type = 'text'
//                 id = 'ebcssInput'
//                 placeholder = 'Enter here'
//                 otherAttribs = {otherAttribs}
//             />
//             <Button
//                 className = 'ebcss-button'
//                 type = 'submit'
//                 id = 'ebcssButton'
//                 value = {buttonValue}
//                 otherAttribs = {otherAttribs}
//             />
//             <ImgTag 
//                 alt = 'ebImage123456'
//                 src = 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/8196ba0f-98f1-447c-96b9-4382e205dd6c/d6i1q8g-82a274bd-2965-4274-b5b7-f0b75bf8392c.gif'
//             />
//         </div>
//     );
// }

let Atoms = {
    Button,
    ImgTag,
    Input,
    Label,
    UlList
}

export default Atoms;
